const STORAGE_PREFIX = "application-announcement:";
const SESSION_KEY = `${STORAGE_PREFIX}session-id`;

const createSessionId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const getSessionId = () => {
  let sessionId = localStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = createSessionId();
    localStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
};

const dismissalKey = (announcementId) =>
  `${STORAGE_PREFIX}${getSessionId()}:dismissed:${announcementId}`;

export const isApplicationAnnouncementDismissed = (announcementId) =>
  localStorage.getItem(dismissalKey(announcementId)) === "true";

export const dismissApplicationAnnouncement = (announcementId) => {
  localStorage.setItem(dismissalKey(announcementId), "true");
};

export const clearApplicationAnnouncementSession = () => {
  Object.keys(localStorage)
    .filter((key) => key.startsWith(STORAGE_PREFIX))
    .forEach((key) => localStorage.removeItem(key));
};
